var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"header"},[_c('RankingCounterComponent',{on:{"prev":_vm.prev}}),_c('RankingHeaderComponent')],1),_c('RankingBodyComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }